<template>
	<div class="modal-content sm_padding">
		<div class="modal-header">
			<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
			<h4 class="modal-title text-center">Envie uma mensagem para {{ name }}</h4>
		</div>
		<div class="modal-body">
			<div class="host-info">
				<div class="img">
					<img :src="photo" class="img-circle img-thumbnail" alt="profile-image">
				</div>
				<div class="content text-left">
					<h3 class="m-b-0 m-t-0">{{ name }}</h3>
                    <span v-if="online"><i class="fa fa-circle online m-t-5 m-b-5"></i> Online agora</span>
                    <span v-else class="font-13 m-t-5 m-b-5">Online {{ last_activity }}</span>
                    <span v-if="verified" class="verified m-b-5"><img src="/images/verified.png" alt=""> Conta Verificada</span>
                    <span class="badge badge-gray m-b-15">Taxa de Resposta: {{ response_rate }}
                        <i data-toggle="tooltip" data-placement="top" title="Porcentagem de contatos que esta pessoa respondeu." class="far fa-question-circle"></i>
                    </span>
				</div>
			</div>
			<transition name="fade">
				<div v-if="invitation">
					<div v-if="invitation.fk_status == 2">
						<div class="dv_msg msg_success text-center">
							<img class="icon" src="/images/sent.svg" alt="">
							<h4 class="text-custom">Mensagem enviada com sucesso. E agora?</h4>
							<p>Enviamos sua mensagem para {{ name }}. Fique atento(a) a sua caixa de mensagens e notificações para saber quando {{ name }} te responder.</p>
							<div>
								<hr>
								<p>Aproveite e baixe nosso app, assim você é notificado quando {{ name }} atualizar este convite 😉!</p>
								<div class="row link_app m-b-15">
									<a href="https://play.google.com/store/apps/details?id=com.webquarto.b2c.app&referrer=utm_source%3Dwebquarto_website%26utm_medium%3Dwebsite_footer" target="_blank">
										<img src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png" alt="" width="144" srcset="">
									</a>
									<a href="https://apps.apple.com/br/app/webquarto/id1490298196" target="_blank">
										<img src="https://www.webquarto.com.br/images/appstore.png" alt="" width="120">
									</a>
								</div>
							</div>
							<a :href="'/mensagens/' + fk_user" class="btn btn-success btn-block btn-message-sent">Ver Caixa de Mensagens</a>
						</div>
					</div>
				</div>
			</transition>
			<transition name="fade">
				<form v-if="!msg_success" v-on:submit.prevent="sendMessage()">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <div class="form-group" v-bind:class="{'has-error': errors.has('moving_date')}">
                                <label for="moving_date" class="control-label">Data de Mudança</label>
                                <date-picker
                                    v-model="form.moving_date"
                                    :disabled-date="disabledDate"
                                    :open.sync="open_picker"
                                    value-type="format"
                                    format="DD/MM/YYYY">
                                        <template v-slot:input>
                                            <input type="tel"
                                                class="form-control"
                                                data-vv-as="Data de Mudança"
                                                autocomplete="off"
                                                v-validate="'date_format:dd/MM/yyyy'"
                                                v-mask="'##/##/####'"
                                                placeholder="dd/mm/aaaa"
                                                @input="dateChange"
                                                v-model="form.moving_date" name="moving_date"/>
                                        </template>
                                </date-picker>
                                <span class="help-block text-left" v-show="errors.has('moving_date')">
                                    <strong>{{ errors.first('moving_date') }}</strong>
                                </span>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <div class="form-group" v-bind:class="{'has-error': errors.has('staying_time')}">
                                <label for="staying_time" class="control-label">Tempo de Permanência</label>
                                <select class="form-control" v-model="form.staying_time" data-vv-as="Tempo de Permanência" v-validate="'required'" name="staying_time">
                                    <option value="">Selecione</option>
                                    <option>Menos de 1 mês</option>
                                    <option>Até 3 meses</option>
                                    <option>Até 6 meses</option>
                                    <option>Mais de 6 meses</option>
                                    <option>Indeterminado</option>
                                </select>
                                <span class="help-block text-left" v-show="errors.has('staying_time')">
                                    <strong>{{ errors.first('staying_time') }}</strong>
                                </span>
                            </div>
                        </div>

                    </div>
					<div class="dv_msg_success text-left">
						<div class="form-group" v-bind:class="{'has-error': errors.has('message')}">
                            <label for="message" class="control-label">Mensagem</label>
							<textarea name="message" v-validate="'required'" class="form-control" v-model="form.message" :placeholder="'Digite aqui sua mensagem para ' + name + '.'" rows="4"></textarea>
							<div class="scroll-wrap" data-simplebar>
								<div class="text-helpers">
									<p v-for="(text, index) in text_suggestions" :key="index" @click="copyText(index)">{{ text }}</p>
								</div>
							</div>
							<span class="help-block text-left" v-show="errors.has('message')">
								<strong>{{ errors.first('message') }}</strong>
							</span>
						</div>
					</div>

                    <button type="submit" class="btn btn-success btn-invitation btn-lg btn-block waves-effect waves-light ladda-button">
						<span class="ladda-label">Enviar Mensagem</span>
					</button>
				</form>
			</transition>
		</div>
	</div>
</template>

<script>
import DatePicker from '../../../../../../legacy/node_modules/vue2-datepicker';
import '../../../../../../legacy/node_modules/vue2-datepicker/index.css';
	export default {
        components: {DatePicker},
        props: [
			'name',
            'photo',
            'online',
            'authenticated',
            'fk_property',
            'proommate',
            'response_rate',
            'last_activity',
            'verified',
            'fk_user',
            'location_object',
            'rent_price'
		],
		data: function () {
			return {
                open_picker: false,
				invitation: false,
				msg_success: false,
                roommate: this.proommate,
				form: {
				    message: '',
					fk_user: parseInt(this.fk_user),
					initial_message: 1,
                    fk_property: parseInt(this.fk_property),
                    fk_roommate: parseInt(this.fk_roommate),
                    target: 'p',
                    moving_date: (this.proommate ? this.proommate.moving_date : ''),
                    staying_time: (this.proommate ? this.proommate.staying_time : ''),
                    rent_price: this.rent_price
				},
				text_suggestions: [
					'Tenho interesse neste anúncio.',
					'Este quarto ainda está disponível?',
					'Gostaria de mais informações sobre o quarto.',
				]
			};
        },
        computed: {
            fk_roommate() {
                return this.proommate != false ? this.proommate.id : null;
            },
            contact_capability() {
                return this.fk_roommate ? true : false;
            }
        },
		methods: {
            disabledDate(date) {
                const d = new Date().setHours(0,0,0,0);
                return date < d;
            },
            dateChange() {
                this.open_picker = false;
			},
			copyText(index) {
				this.form.message = this.text_suggestions[index];
			},
            createRoommateAdObject() {
                this.roommate.rent_price = this.rent_price;
                this.roommate.moving_date = this.form.moving_date;
                this.roommate.staying_time = this.form.staying_time;
                this.roommate.fk_city = this.location_object.fk_city;
                this.roommate.fk_state = this.location_object.fk_state;
                this.roommate.district = this.location_object.district;
                this.roommate.lat = this.location_object.lat;
                this.roommate.lng = this.location_object.lng;
                this.roommate.has_address = true;
                delete this.roommate.wanted_amenities;
            },
			sendMessage () {
				this.$validator.validateAll().then((result) => {
					if (!result)
						return;

					const l = Ladda.create( this.$el.querySelector('.ladda-button') );
                    l.start();

                    const form = this.form;

                    const obj = this.proommate;
                    obj.rent_price = this.rent_price;
                    obj.moving_date = this.form.moving_date;
                    obj.staying_time = this.form.staying_time;
                    obj.fk_city = this.location_object.fk_city;
                    obj.fk_state = this.location_object.fk_state;
                    obj.district = this.location_object.district;
                    obj.lat = this.location_object.lat;
                    obj.lng = this.location_object.lng;
                    obj.has_address = true;
                    delete obj.wanted_amenities;

                    form.roommate_ad = obj;

					axios.post('/message/send-message', form).then((response) => {
						l.stop();
						const data = response.data;
						if (data.success) {
							window.App.success('Mensagem enviada com sucesso! Fique atento a sua Caixa de Mensagens.');
							window.dataLayer.push({
								'event': 'init_contact_ad',
								'event_category': 'property_ad_page',
								'event_label': 'init_contact_ad',
							});
							this.msg_success = true;
							this.invitation = data.invitation;

                            window.dataLayer.push({
                                event: 'send_message_ab_test',
                                event_category: 'property_ad_detail_ab_test',
                                event_label: 'variant_a'
                            });

							EventBus.$emit('update-message-sent', null, { res: true });

						}
					}).catch(function (error) {
						l.stop();

						if (error.response && error.response.status == 401) {
							EventBus.$emit('open-modal', 'register-modal');
							window.dataLayer.push({
								'event': 'show_login_modal',
								'event_category': 'property_ad_page',
								'event_label': 'send_message',
							});
							EventBus.$emit('close-modal');

						} else if (error.response && error.response.status == 403) {
							window.App.error('Você não pode enviar uma mensagem para esta pessoa!');
						} else
							window.App.error('Ocorreu um erro ao enviar sua mensagem. Atualize esta página e tente novamente!');
					});
				});
			},
		},
		created() {
			this.$validator.localize('pt_BR', {
				messages: {
					required: 'Preencha uma mensagem no campo acima.',
				},
			});
		},
	}
</script>


<style lang="scss" scoped>
	.sm_padding {
		padding: 15px !important;
	}

	.app img.icon {
		width: 45px;
	}

	.scroll-wrap {
		overflow-y: hidden;
		width: 100%;
        padding-bottom: 10px;
	}

	.text-helpers {
		display: flex;
		width: max-content;
		margin-top: 15px;
		p {
			cursor: pointer;
			margin-right: 5px;
			border: 1px solid #55748F;
			padding: 5px 10px;
			color: #55748F;
			font-size: 12px;
			border-radius: 16px;
		}
	}

    textarea {
        min-height: 110px;
    }

	.dv_msg {
		border: none !important;
	}

	.host-info {

		display: flex;

		.content {
			display: flex;
			flex-direction: column;
		}

	}

	.row.link_app {
		display: flex;
		align-items: center;
		margin-top: 15px;

		.col-xs-6 {
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
</style>
